import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

// Animated gavel: hammer taps down onto a base, ring ripples on each strike.
export default function AnimatedGavel({ size = 140 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Ripple on strike */}
      <motion.div
        style={{
          position: 'absolute',
          bottom: size * 0.16,
          width: size * 0.6,
          height: 2,
          borderRadius: '50%',
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.5), transparent)',
        }}
        animate={{ scaleX: [0.4, 1.6, 0.4], opacity: [0, 0.9, 0] }}
        transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeOut',
          times: [0, 0.35, 1],
        }}
      />

      <svg
        width={size * 0.7}
        height={size * 0.7}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', zIndex: 1 }}
      >
        {/* Anvil / sound-block base */}
        <rect
          x="20"
          y="78"
          width="60"
          height="6"
          rx="2"
          fill="rgba(255,255,255,0.85)"
        />

        {/* The gavel — rotates around its handle pivot then snaps down */}
        <motion.g
          style={{ transformOrigin: '68px 62px' }}
          animate={{ rotate: [-20, 8, -20] }}
          transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: [0.4, 0, 0.2, 1],
            times: [0, 0.35, 1],
          }}
        >
          {/* Handle */}
          <rect
            x="30"
            y="60"
            width="38"
            height="4"
            rx="2"
            fill="rgba(255,255,255,0.85)"
          />
          {/* Head */}
          <rect
            x="60"
            y="50"
            width="20"
            height="22"
            rx="3"
            fill="#ffffff"
          />
          {/* Head trim */}
          <rect
            x="60"
            y="49"
            width="20"
            height="3"
            rx="1.5"
            fill="rgba(255,255,255,0.6)"
          />
        </motion.g>
      </svg>
    </Box>
  );
}
